import type { Recipe } from '../../types'
import { image, ingredient, section } from '../helpers'

export const gaufres: Recipe = {
  slug: 'gaufres',
  title: 'Gaufres liégeoises',
  category: 'sucré',
  description: 'Des gaufres liégeoises caramélisées, pour environ 10 pièces.',
  image: image('gaufres'),
  tags: ['goûter', 'levée', 'gaufrier'],
  meta: [
    { label: 'Préparation', value: '30 à 45 min + 45 à 60 min de repos' },
    { label: 'Cuisson', value: '2 min 30 à 3 min par gaufre' },
  ],
  sections: [
    section('Ingrédients', [
      ingredient('farine', 'farine', '500 g de farine', { amount: 500, unit: 'g', shoppingKey: 'farine' }),
      ingredient('sucre', 'sucre', '40 g de sucre (éventuellement vanillé)', {
        amount: 40,
        unit: 'g',
        shoppingKey: 'sucre',
      }),
      ingredient('lait', 'lait tiède', '200 g de lait tiède', {
        amount: 200,
        unit: 'g',
        shoppingKey: 'lait',
      }),
      ingredient('levure', 'levure sèche', '7 g de levure sèche (ou 21 g de levure fraîche)', {
        amount: 7,
        unit: 'g',
        shoppingKey: 'levure',
      }),
      ingredient('fleur', 'eau de fleur d’oranger', '3 c. à soupe d’eau de fleur d’oranger'),
      ingredient('sel', 'sel', '6 g de sel', { amount: 6, unit: 'g', shoppingKey: 'sel' }),
      ingredient('beurre', 'beurre', '225 g de beurre', { amount: 225, unit: 'g', shoppingKey: 'beurre' }),
      ingredient('sucre-perle', 'sucre perlé', '200 g de sucre perlé', {
        amount: 200,
        unit: 'g',
        shoppingKey: 'sucre perlé',
      }),
    ]),
  ],
  steps: [
    'Sortir le beurre du réfrigérateur et le découper en morceaux d’environ 25 g.',
    'Délayer la levure dans le lait tiède si vous utilisez de la levure fraîche.',
    'Mettre dans le bol du KitchenAid la farine, le sucre, le lait, la levure, la fleur d’oranger et le sel — laisser le beurre de côté pour l’instant.',
    'Pétrir au crochet à vitesse 2–4 jusqu’à obtention d’une pâte homogène ; elle ne doit pas s’effriter ni être trop liquide.',
    'Ajouter le beurre morceau par morceau, en attendant après chaque ajout que le précédent soit absorbé (vitesse 2–4).',
    'La pâte doit devenir lisse, brillante et rester groupée autour du crochet (si elle est trop liquide, c’est qu’il y a eu trop de beurre).',
    'Couvrir et laisser reposer 45 à 60 minutes : la pâte doit gonfler (environ 150 % du volume initial).',
    'Optionnel : mettre la pâte au froid 15 minutes pour faciliter la formation des pâtons.',
    'Ajouter délicatement 200 g de sucre perlé à la main ou avec une cuillère en bois.',
    'Préchauffer le gaufrier à 190 °C puis former des pâtons d’environ 130 g et les laisser à couvert 15 minutes. Cuire 2 min 30 à 3 min par gaufre.',
  ],
  warning:
    'Ne surtout pas ajouter de farine pour façonner les pâtons : cela brûle facilement dans le gaufrier. Pour éviter que la pâte colle, préférez un passage bref au froid (environ 15 minutes) et/ou trempez vos mains dans de l’eau froide avant de façonner.',
  note: 'Attendre au moins deux minutes avant d’ouvrir le gaufrier. Pour conserver la texture des gaufres, les faire refroidir sur une grille.',
}
